<template>
  <div class="login">
    <div class="box">
      <div class="tap-menu">
        <div
          class="user"
          @click="setUserType('user')"
          :class="{ 'selected-box': form.type === 'user' }"
        >
          <span class="text" :class="{ selected: form.type === 'user' }"
            >USER</span
          >
        </div>
        <div
          class="photographer"
          @click="setUserType('photographer')"
          :class="{ 'selected-box': form.type === 'photographer' }"
        >
          <span class="text" :class="{ selected: form.type === 'photographer' }"
            >PHOTOGRAPHER</span
          >
        </div>
      </div>
      <div class="body">
        <div class="social-box">
          <div class="facebook" @click.stop="facebook">
            <img src="../../../assets/images/social_icon/facebook.svg" />
          </div>
          <div class="twitter" @click.stop="twitter">
            <img src="../../../assets/images/social_icon/twitter.svg" />
          </div>
        </div>
        <div class="or">
          <span>OR</span>
        </div>
        <div class="form">
          <form v-on:submit.prevent="login">
            <input-email
              :value="form.email"
              v-on:model="v => (form.email = v)"
              :required="true"
            ></input-email>
            <input-password
              :value="form.password"
              v-on:model="v => (form.password = v)"
              :required="true"
            ></input-password>
            <div class="forget-password" @click.stop="forgetPassword">
              <span>Forgot password?</span>
            </div>
            <hr />
            <div class="remember" @click.stop="emailSaveToCookie">
              <label for="rememberCheck">
                <input type="checkbox" id="rememberCheck" />
                <span>Remember me</span>
              </label>
            </div>
            <div class="form-login">
              <button type="submit">
                <span>LOGIN</span>
              </button>
            </div>
          </form>
        </div>
        <div class="sign-up">
          <span class="text">Not register yet?</span>
          <button @click.stop="signup">
            <span>Sign up</span>
          </button>
        </div>
      </div>
      <div class="error-box">
        <div class="message">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'browser-cookies'
import { defaultAuth, firebaseConnection } from '../../../library/firebase'
import { InputEmail, InputPassword } from '../../common/form-elemnets'
import * as types from '../../../store/mutation-types'

export default {
  name: 'login',
  components: {
    InputPassword,
    InputEmail
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        type: 'user'
      },
      errorMessage: ''
    }
  },
  created() {
    this.form.email = Cookies.get('email')
  },
  methods: {
    forgetPassword() {
      let email = prompt('Email', '') // <-- for IE
      if (email) {
        console.log(email)
        defaultAuth
          .sendPasswordResetEmail(email)
          .then(() => {
            // Email sent.
            alert('success')
          })
          .catch(error => {
            // An error happened.
            alert(error)
          })
      }
    },
    emailSaveToCookie() {
      // console.log(this.form)
      // console.log('host:', window.location.host)
      // console.log('Cookie:', Cookies.get('email'))
      if (this.form.email !== null) {
        if (Cookies.get('email') !== null) {
          // console.log('erase')
          Cookies.erase('email')
        } else {
          // console.log('set')
          Cookies.set('email', this.form.email, {
            expires: 365,
            secure: true,
            domain: window.location.host
          })
        }
      }
    },
    /**
     * Email/password login
     */
    login() {
      if (this.form.email !== '' && this.form.password !== '') {
        defaultAuth
          .signInWithEmailAndPassword(this.form.email, this.form.password)
          .then(snapshot => {
            new Promise(resolve => {
              const user = snapshot.user
              const uid = user.uid
              const userForm = {
                emailVerified: user.emailVerified,
                lastSignInTime: firebaseConnection.firestore.FieldValue.serverTimestamp()
              }

              resolve({
                userForm: userForm,
                uid: uid
              })
            }).then(result => {
              // 유저 정보 업데이트
              this.$store
                .dispatch(types.UPDATE_USERINFO, {
                  form: result.userForm,
                  uid: result.uid
                })
                .then(() => {
                  console.log('user login updated')
                  this.goToMain()
                })
            })
          })
          .catch(error => {
            // Handle Errors here.
            // const errorCode = error.code
            this.errorMessage = error.message
          })
      } else {
        alert('You have to input your email/password.')
      }
    },
    /**
     * facebook login
     * 로그인 할 때마다, 정보를 갱신 해줘야 한다.
     */
    facebook() {
      const provider = firebaseConnection.auth.FacebookAuthProvider()
      defaultAuth.signInWithPopup(provider).then(result => {
        // This gives you a Facebook Access Token.
        const token = result.credential.accessToken
        // The signed-in user info.
        const user = result.additionalUserInfo.profile
        const uid = result.user.uid

        const userForm = {
          name: user.name,
          firstName: user.first_name,
          lastName: user.last_name,
          birthday: user.birthday,
          email: user.email,
          facebookId: user.id,
          facebookLink: user.link,
          locale: user.locale,
          gender: user.gender,
          emailVerified: result.user.emailVerified,
          creationTime: new Date(result.user.metadata.creationTime),
          lastSignInTime: new Date(result.user.metadata.lastSignInTime),
          photoUrl: user.picture.data.url,
          facebookAccessToken: token,
          ageRangeMin: user.age_range.min,
          timezone: user.timezone,
          facebookVerified: user.verified,
          providerId: result.additionalUserInfo.providerId
        }

        if (result.additionalUserInfo.isNewUser) {
          // new user
          userForm.type = this.form.type
          this.$store
            .dispatch(types.SET_SIGNUP, { user: userForm, uid: uid })
            .then(this.goToMain)
        } else {
          this.$store
            .dispatch(types.UPDATE_USERINFO, { form: userForm, uid: uid })
            .then(() => {
              console.log('user information updated')
              this.goToMain()
            })
        }
      })
    },
    /**
     * twitter login
     * 로그인 할 때마다, 정보를 갱신 해줘야 한다.
     */
    twitter() {
      let provider = firebaseConnection.auth.TwitterAuthProvider()
      defaultAuth.signInWithPopup(provider).then(result => {
        console.log('twitter', result)
        // For accessing the Twitter API.
        // const token = result.credential.accessToken
        // const secret = result.credential.secret
        // // The signed-in user info.
        // const user = result.user

        this.$store
          .dispatch(types.UPDATE_USERINFO, { uid: result.uid })
          .then(this.goToMain)
      })
    },
    signup() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'signup',
        active: true,
        type: 'full'
      })
    },
    goToMain() {
      this.$store
        .dispatch(types.SET_MODAL_COMPONENT, {
          component: '',
          active: false,
          type: 'full'
        })
        .then(() => {
          if (this.$store.getters.userInfo.type === 'photographer') {
            this.$router.push({ path: '/photographer/request' })
          } else {
            this.$router.push({ path: '/main' })
          }
        })
    },
    setUserType(type) {
      this.form.type = type
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  height: 693px;
  width: 480px;
  display: flex;
  justify-content: center;
  flex-flow: row wrap;

  hr {
    border: 0.5px solid gray;
  }

  .box {
    position: relative;
    margin: auto;
    background-color: #ffffff;
    border: 1px solid gray;
    height: inherit;
    width: inherit;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    .tap-menu {
      position: relative;
      height: 60px;
      width: 100%;
      /*overflow: hidden;*/
      display: -webkit-flex;
      display: flex;
      -webkit-flex-direction: row;
      flex-direction: row;

      .user {
        min-width: 50%;
        height: inherit;
        text-align: center;
        border-right: solid 1px #e7e7e7;
        border-bottom: solid 1px #e7e7e7;
        -webkit-flex: auto;
        flex: auto;
        vertical-align: middle;
        line-height: 60px;
      }

      .photographer {
        height: inherit;
        vertical-align: middle;
        border-bottom: solid 1px #e7e7e7;
        text-align: center;
        -webkit-flex: auto;
        flex: auto;
        min-width: 50%;
        line-height: 60px;
      }

      .selected-box {
        border-bottom: 0;
      }

      .selected {
        font-weight: 600 !important;
        color: #ab08b6 !important;
      }

      .text {
        cursor: pointer;

        font-size: 16px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: center;
        color: #000000;
      }
    }

    .body {
      position: relative;
      margin: 29px 70px auto 70px;
      left: 0;
      right: 0;
      /*border: 1px solid gray;*/
      height: auto;

      .title {
        width: 87px;
        height: 26px;

        span {
          font-family: Poppins;
          font-size: 16px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: 1px;
          line-height: 26px;
          color: #000000;
        }
      }

      .social-box {
        margin: 16px 0 0 0;
        position: relative;
        height: 60px;
        width: 100%;
        overflow: hidden;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-direction: row;
        flex-direction: row;

        img {
          position: absolute;
          margin: auto;
          left: 0;
          right: 0;
          width: 100px;
          top: -20px;
        }

        .facebook {
          margin: 0 20px 0 0;
          position: relative;
          -webkit-flex: auto;
          flex: auto;
          min-width: 40%;
          border: 1px solid #eaeaea;
          overflow: hidden;
        }

        .twitter {
          position: relative;
          -webkit-flex: auto;
          flex: auto;
          min-width: 40%;
          border: 1px solid #eaeaea;
          overflow: hidden;
        }
      }

      .or {
        width: 25px;
        height: 26px;
        position: relative;
        margin: 20px auto 0 auto;

        span {
          font-family: Poppins;
          font-size: 16px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: 1px;
          color: #000000;
        }
      }

      .sign-up {
        margin: 24px 0 0 0;
        text-align: center;

        .text {
          font-family: Poppins;
          font-size: 14px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #000000;
        }

        button {
          cursor: pointer;
          border: 0;
          background-color: transparent;

          span {
            font-size: 14px;
            font-weight: 300;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: right;
            color: #000bff;
          }
        }
      }
    }

    .form {
      margin: 0;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;

      input {
        width: 260px;
        height: 50px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        color: #000000;
        padding: 0 16px 0 16px;
        margin: 10px 0 0 0;
        background-color: #ffffff;
        border: solid 1px #e7e7e7;
        outline: none;
      }

      .forget-password {
        cursor: pointer;
        position: relative;
        margin: 5px 0 0 0;
        float: right;

        span {
          font-family: Poppins;
          font-size: 14px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #0f00ff;
        }
      }

      hr {
        margin: 40px 0 0 0;
        border-color: #e7e7e7;
      }

      .remember {
        width: 160px;
        position: relative;
        margin: 8px auto 0 auto;

        label {
          height: 0;
          margin: 0;
          cursor: pointer;
        }

        span {
          line-height: 20px;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #000000;
        }

        input[type='checkbox'] {
          cursor: pointer;
          width: 20px;
          height: 20px;
          opacity: 0.54;
          border: solid 1px #000000;
          background-color: #ffffff;
          position: relative;
          top: 5px;
        }
      }

      .form-login {
        margin: 20px 0 0 0;
        width: 260px;
        height: 50px;

        button {
          cursor: pointer;
          width: 260px;
          height: 50px;
          border-radius: 2px;
          background-color: #000bff;
          border: 0;
        }

        span {
          font-family: Poppins;
          font-size: 14px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: 1px;
          text-align: center;
          color: #ffffff;
        }
      }
    }

    .error-box {
      width: 440px;
      height: 108px;
      background-color: #f5f5f5;
      .message {
        color: red;
        margin: 5px;
      }
    }
  }
}
</style>
